import { Role } from "../constant/role"
import { LocalAuthorityDebtSimplifiedYearModel } from "./local-authority-crd-year"

export interface Account extends Manageable {
    addedOn: Date
    class: Class
    defaultChapter: Chapter
    expense: boolean
    id: number
    label: string
    number: string
    operation: boolean
    receipts: boolean
    removedOn: Date
    template: boolean
}

export interface AxeAnalytique extends Manageable {
    codeAxe: string
    debutValidite: number
    finValidite?: number
    identifiantAxeGF: number
    identifiantCollectiviteGF: number
    libelleAxe: string
}

export interface Bank extends Manageable {
    id: number
    label: string
}

export interface BergerLevrault {
    axe: 1 | 2
    budget: number
    idAxe: number
    localAuthority: LocalAuthority
    idCollectiviteGF: number
    port: number
    server: string
    enabled: boolean
}

export interface BergerlevraultLocalauthority {
    adresse1: string
    adresse2: string
    adresse3: string
    code: string
    codePostal: string
    fax: string
    idCollectiviteGF: number
    nom: string
    siren: string
    telephone: string
    ville: string
}

export interface Budget {
    idBudgetGF: number
    idCollectiviteGF: number
    codeBudget: string
    nomBudget: string
    siret: string
}

export interface Chapter extends Manageable {
    id: number
    instruction: Instruction
    label: string
    number: string
    types: ChapterOperationType[]
}

export interface ChapterOperationType {
    expense: boolean
    operationType: OperationType
    receipts: boolean
}

export interface Class extends Manageable {
    id: number
    number: string
    label: string
    description: string
    instruction: Instruction
    accounts: Account[]
}

export interface Demography {
    population: number
    year: number
}

export interface Grant {
    id: number
    localAuthority: LocalAuthority
    name: string
}

export interface ServiceGroup {
    id: number
    label: string
    localAuthority: number
    services: number[]
    slug: string
}

export interface Instruction extends Manageable {
    accounts: Account[]
    chapters: Chapter[]
    classes: Class[]
    id: number
    name: string
}

export interface InterestVariation extends LoanVariation {
    interest: number
}

export interface Loan extends Manageable {
    amount: number
    bank: Bank
    constantAmortization: boolean
    contractedOn: Date
    duration: number
    id: number
    interestVariations: InterestVariation[]
    localAuthority: LocalAuthority
    number: string
    periodicity: number
    rate: number
    rateVariations: RateVariation[]
    reimboursedCapitalVariations: ReimboursedCapitalVariation[]
    simulate: boolean
    subject: string
    variableRate: boolean
    detteRecuperable: boolean
}

export interface LoanDecomposition {
    interests: number[]
    paymentAmounts: number[]
    paymentDates: Date[]
    periodicRates: number[]
    reimboursedCapitals: number[]
    remainingCapitals: number[]
}

export interface LoanWithDecomposition {
    decomposition: LoanDecomposition
    loan: Loan
}

export interface LocalAuthority extends Manageable {
    accounts: LocalAuthorityChapterAccount[]
    bergerLevrault: BergerLevrault
    code: string
    demographies: Demography[]
    glossary: Word[]
    approaches?: Word[]
    id: number
    instruction: Instruction
    loans: Loan[]
    maximumDebtRefund: number
    maximumDeleveragingYears: number
    minimumGrossCashFlow: number
    name: string
    observations: Observation[]
    rests: Rest[]
    results: Result[]
    slug: string
    users: User[]
    members?: any
    politicalApproach?: boolean
    parent?: any
    monthlyCountersFillingReminder: boolean
    notificationAfterCountersImport: boolean
    lastImportDate?: Date
    isDebtSimplified?: boolean
    localAuthorityDebtSimplifiedYears?: LocalAuthorityDebtSimplifiedYearModel[]
}

export interface LocalAuthorityChapterAccount {
    account: Account
    chapter: Chapter
}

export interface Manageable {
    createdAt?: Date
    creator?: User
    updatedAt?: Date
    updater?: User
}

export interface Observation extends Manageable {
    id: number
    localAuthority: LocalAuthority
    account: Account
    amount: number
    receipts: boolean
    year: number
}

export interface OperationType {
    id: "EQUIPMENT" | "FINANCIAL" | "ORDER"
}

export interface PpiYearLoan {
    interests: number
    reimbourse: number
    remaining: number
    total: number
    year: number
    reimbours?: number
}

export interface RateVariation extends LoanVariation {
    rate: number
}

export interface Region extends Manageable {
    id: number
}

export interface RegionName extends Manageable {
    region: string
}

export interface ReimboursedCapitalVariation extends LoanVariation {
    reimboursedCapital: number
}

export interface RepeatedPassword {
    first: string
    second: string
}

export interface Rest {
    localAuthority: LocalAuthority
    receipt: boolean
    amount: number
    year: number
}

export interface Result {
    localAuthority: LocalAuthority
    operation: boolean
    amount: number
    year: number
}

/** Defini comme "Element Analytique" du côté de Berger Levrault, côté SFP ce sera les services */
export interface ElementAnalytiqueBergerLevrault {
    classement: boolean
    codeElement: string
    debutValidite: number
    finValidite: number
    identifiantAxeGF: number
    identifiantElementAnalytiqueGF: number
    identifiantElementAnalytiqueParentGF: number
    identifiantFonctionAnalyseGF: number
    libelleElement: string
    priorite: number
}

export interface Title {
    id: number
    shortLabel: string
    longLabel: string
}

export interface User extends Manageable {
    id?: number
    consultedLocalAuthority: number
    email?: string
    enabled?: boolean
    firstName?: string
    lastName?: string
    Adminbudgetannexe: string
    Consultantbudgeannexe: string
    managedLocalAuthority: number
    region: Region
    phone1?: string
    phone2?: string
    roles: Role[]
    serviceBudgetAnnexes: any
    title: number
    managedBudgetAnnexes: Number[]
    consultedBudgetAnnexes: Number[]
    username?: string
    relatedLocalAuthority?: string
    relatedLocalAuthoritySlug?: string
    services_annexes_list: any
}

// export interface SelectedUser extends Manageable {
// 	id: number
// }

export interface Region extends Manageable {
    id: number
    name: string
    localAuthorities: any
}

export interface LoanVariation {
    id: number
    paymentDateIndex: number
}

export interface SituationRecord {
    id: number
    label: string
    engaged: number
    liquidated: number
    localAuthority: number
    planned: number
    service: number
    updatedAt: Date
}

export interface Ppi extends Manageable {
    expenses: PpiExpense[]
    fctva: number
    fctvaRetrieve: number
    id: number
    investment_themes: PpiInvestmentTheme[]
    localAuthority: LocalAuthority
    name: string
    prospLength: number
    revenues: PpiRevenue[]
    thirdParties: boolean
    years: PpiYear[]
}

export interface PpiExpense extends Manageable {
    id: number
    name: string
    ppi: Ppi
    years: PpiExpenseYear[]
}

export interface PpiExpenseYear {
    id: number
    ppi_expense: PpiExpense
    value: number
    year: number
}

export interface PpiInvestmentProject extends Manageable {
    accounting_article: number
    budget: number
    description: string
    fctva: boolean
    grants: PpiInvestmentProjectGrant[]
    id: number
    induceds: ProjectInduced[]
    name: string
    operation_number: number
    priority: number
    theme: PpiInvestmentTheme
    visible: boolean
    years: PpiInvestmentProjectYear[]
}

export interface PpiInvestmentProjectGrant extends Manageable {
    awarded: boolean
    budget: number
    id: number
    grant: Grant
    project: PpiInvestmentProject
    years: PpiInvestmentProjectGrantYear[]
}

export interface PpiInvestmentProjectGrantYear extends Manageable {
    amount: number
    grant: PpiInvestmentProjectGrant
    id: number
    year: number
}

export interface PpiInvestmentProjectYear extends Manageable {
    amount: number
    id: number
    ppi_investment_project: PpiInvestmentProject
    year: number
}

export interface PpiInvestmentTheme extends Manageable {
    id: number
    name: string
    parent: PpiInvestmentTheme
    ppi: Ppi
    projects: PpiInvestmentProject[]
    responsible: User
    themes: PpiInvestmentTheme[]
}

export interface PpiRevenue extends Manageable {
    id: number
    name: string
    ppi: Ppi
    years: PpiRevenueYear[]
}

export interface PpiRevenueYear extends Manageable {
    id: number
    ppi_revenue: PpiRevenue
    value: number
    year: number
}

export interface PpiYear extends Manageable {
    deficitRecovery: number
    fctva: number
    fctvaRetrieve: number
    id: number
    planningFee: number
    ppi: Ppi
    previousSurplus: number
    saleOfHeritage: number
    selfFinancing: number
    tpoRevenue: number
    tpoSpending: number
    year: number
    loanDebtAmount?: number;
}

export interface ProjectInduced {
    gain: number
    id: number
    induced: Account
    loss: number
    project: PpiInvestmentProject
    year: number
}

export interface Theme {
    theme_id: number
    account_id: number
    amount: number
    localAuthority: string
    slug: string
}

export interface Scenario extends Manageable {
    accounts: ScenarioAccount[]
    chapters: ScenarioChapter[]
    comments: string
    description: string
    id: number
    identifier: number
    previousResult: number;
    themes: ScenarioAccountTheme[]
    validated: boolean
    validated_themes: ScenarioTheme[]
    year: number
    years: ScenarioYear[]
}

export interface ScenarioAccount extends Manageable {
    account_id: number
    amount: number
    chapter_id: number
    id: number
    receipts: boolean
    comment?: string
}

export interface ScenarioAccountTheme extends Manageable {
    account_id: number
    account_name: string
    amount: number
    comment?: string
    id: number
    receipts: boolean
    theme_id: string
    theme_slug: string
}

export interface ScenarioChapter extends Manageable {
    amount: number
    chapter_id: number
    id: number
    receipts: boolean
    comment?: string;
}

export interface ScenarioTheme extends Manageable {
    id: number
    theme_id: number
    validated: boolean
}

export interface ScenarioYear extends Manageable {
    accounts: ScenarioYearAccount[]
    id: number
    previous: number
    year: number
}

export interface ScenarioYearAccount extends Manageable {
    account_id: number
    amount: number
    chapter_id: number
    id: number
    percentile: boolean
    receipts: boolean
    comment: string
}

export interface Service {
    code: string
    description?: string
    id: number
    label: string
    localAuthority: number
    plannedConsumption: number
    serviceGroup: number
    slug: string
    approaches: any
}

export interface Summable<T> {
    item: T
    action: SummableAction
}

export interface Token {
    access_token: string
    expires_in: number
    refresh_token: string
    scope: any
    token_type: "bearer"
}

export enum SummableAction {
    Add,
    Subtract
}

export interface Word {
    id: number
    localAuthority: LocalAuthority
    term: string
    definition: string
    Politique: any
}

export interface MotDto {
    section: string
    soussection: string
    mot: string
    definition: string
}



// WEBPACK FOOTER //
// ./src/model/index.ts